import { FirebaseAuthTypes } from '@react-native-firebase/auth'
import { useEffect, type PropsWithChildren } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { auth, onAuthStateChanged, onSnapshot } from '~providers/firebase'
import { ApplicationState } from '~redux'
import { getAuth, setProfile } from '~redux/auth'
import { Profile } from '~types'
import ProfileService from '~services/profile'

const useUser = () => {
  const dispatch = useDispatch()
  const { loading, user } = useSelector((state: ApplicationState) => state.auth)

  useEffect(() => {
    const subscriber = onAuthStateChanged(auth, (user: FirebaseAuthTypes.User | null) => {
      dispatch(getAuth(user))
    })
    return subscriber
  }, [dispatch])

  // Watch for changes in the user profile
  useEffect(() => {
    if (user) {
      let cancel = false
      // TODO: withConverter
      const subscription = onSnapshot(ProfileService.getProfile(user.uid), (snapshot) => {
        if (!cancel) {
          dispatch(setProfile(snapshot.data() as Profile))
        }
      })

      return () => {
        cancel = true
        subscription()
      }
    }
  }, [user, dispatch, loading])

  return { loading }
}

export function SessionProvider({ children }: PropsWithChildren) {
  useUser()

  return children
}
